/// Counters shown at the top of the "Talk to the developer" page.
///
/// Calls the `recordDevBlogVisit` Cloud Function once per page mount:
/// every visit bumps `viewCount`, and the first visit by a given
/// Firebase Auth UID also bumps `uniqueVisitorCount`. Returns both
/// totals. Counter doc lives at `webStats/devBlog` and is
/// server-written only — clients never write it directly, so a
/// Firestore rule for the doc isn't needed and the counts can't be
/// inflated from a console.

import { httpsCallable } from 'firebase/functions'
import { firebaseFunctions } from '../firebase/app'

export interface DevBlogVisitResult {
  viewCount: number
  uniqueVisitorCount: number
}

export async function recordDevBlogVisit(): Promise<DevBlogVisitResult> {
  const fn = httpsCallable<unknown, DevBlogVisitResult>(
    firebaseFunctions,
    'recordDevBlogVisit',
  )
  const res = await fn({})
  return res.data
}
